import { Link } from 'react-router-dom'
import { Sparkles, CreditCard, Mail, Palette } from 'lucide-react'

export default function HomePage() {
  const openPolicy = (filename: string) => {
    window.open(`/${filename}`, '_blank')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto text-center">
          {/* Hero Section */}
          <div className="mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Sku Studio
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              AI 驱动的电商产品图片生成平台
            </p>
            <p className="text-lg text-gray-500 max-w-3xl mx-auto">
              使用先进的 AI 技术，将您的产品照片提升到专业电商级别
            </p>
          </div>

          {/* Features */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white rounded-lg p-8 shadow-sm border">
              <Sparkles className="w-12 h-12 text-blue-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                AI 图片编辑
              </h3>
              <p className="text-gray-600">
                采用 AI 图像处理技术，智能优化产品照片的光线、背景和细节
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm border">
              <CreditCard className="w-12 h-12 text-green-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                积分制度
              </h3>
              <p className="text-gray-600">
                灵活的积分系统，随用随付，登录即送积分，先到先得
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm border">
              <Mail className="w-12 h-12 text-purple-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                安全的邮箱验证系统
              </h3>
              <p className="text-gray-600">
                完整的用户验证流程，确保账户安全和服务质量
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm border">
              <Palette className="w-12 h-12 text-orange-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                专业电商图片生成
              </h3>
              <p className="text-gray-600">
                专为电商平台优化的图片处理，提升产品展示效果和转化率
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link 
              to="/register"
              className="btn-primary text-lg px-8 py-3 rounded-lg"
            >
              开始使用
            </Link>
            <Link 
              to="/login"
              className="btn-secondary text-lg px-8 py-3 rounded-lg"
            >
              登录
            </Link>
          </div>

          {/* Policy Links */}
          <div className="text-sm text-gray-500 max-w-2xl mx-auto">
            <p className="leading-relaxed">
              使用本服务即表示您同意我们的{' '}
              <button 
                onClick={() => openPolicy('TERMS_OF_USE.txt')}
                className="text-blue-600 hover:text-blue-700 underline"
              >
                使用条款
              </button>
              {' '}和{' '}
              <button 
                onClick={() => openPolicy('PRIVACY_POLICY.txt')}
                className="text-blue-600 hover:text-blue-700 underline"
              >
                隐私政策
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}